import axios from "../../config/axiosConfig";
import {
  REVERSE_GST_CHARGE_REPORT_REQUEST,
  REVERSE_GST_CHARGE_REPORT_SUCCESS,
  REVERSE_GST_CHARGE_REPORT_FAILURE,
} from "../types/reverse-gst-charge-report-types";

export const getReverseGstChargeReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: REVERSE_GST_CHARGE_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/reverse-gst-charge-report/getReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('<<<Purchase API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: REVERSE_GST_CHARGE_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching reverse gst charge Report:", error);
        dispatch({ type: REVERSE_GST_CHARGE_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching reverse gst charge Report:", error);
      dispatch({ type: REVERSE_GST_CHARGE_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearReverseGstChargeReport = () => {
  return async (dispatch) => {
        dispatch({ type: REVERSE_GST_CHARGE_REPORT_SUCCESS, payload: {} });
  }
}
